import React, { useEffect, useState } from "react";
import { SlovHeader } from "./cardsHeader";

export const CardsDescShortScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    const [slovtext, setslovtext] = useState("");
    const [charCount, setCharCount] = useState(10);

    const maxLength = 10;
    const allowedRegex = /^[0-9a-zA-Zа-яА-ЯёЁ ]*$/;

    const handleInputChange = (e) => {
        const inputText = e.target.value;

        if (inputText.length <= maxLength && allowedRegex.test(inputText)) {
            setslovtext(inputText);
            setCharCount(maxLength - inputText.length);
        }
    };

    const isInputEmpty = slovtext.trim() === "";

    return (
        <div id="game">
            <SlovHeader />

            <img
                src={props.PColors !== undefined ? "https://cyberbox.trgu.ru/public/avatars/cards/PlayerMain" + (props.PColors + 1) + ".png" : "Аватар загружается\n"}
                alt="Player Avatar"
            />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />

            <img
                src={"https://cyberbox.trgu.ru/public/cardsgame/" + props.TextString + ".jpg"}
                alt="Card"
                style={{ width: "80%", maxWidth: "300px" }}
            />
            <br />

            <p style={{ fontSize: "18px", color: "black" }}>Опишите картинку за 10 символов</p>

            <textarea
                autoComplete="off"
                className="FormInput"
                style={{ width: "80%", height: "2em" }}
                placeholder="Описание"
                maxLength={maxLength}
                value={slovtext}
                onChange={handleInputChange}
            />

            <div className="charCount" style={{ color: "black" }}>
                Осталось символов: {charCount}
            </div>
            <br />

            <button
                type="button"
                disabled={isInputEmpty}
                onClick={() => {
                    props.sendMessage(`sendtoserver|slov\\addtext\\` + slovtext);
                    setslovtext("");
                    setCharCount(maxLength);
                }}
            >
                Отправить
            </button>
        </div>
    );
};